import React from "react"
import { slugify } from "../../utils"
import BgColor, { HarviaBackgroundColor } from "../layouts/BgColor"
import * as styles from "./SubHeading.module.scss"

export type SubHeadingProps = { text?: string | null; bgColor?: HarviaBackgroundColor }

const SubHeading = (props: SubHeadingProps) => {
  //console.log('Rendering SubHeading', props)
  if (!props.text) return null
  return (
    <BgColor id={slugify(props.text)} color={props.bgColor} className={styles.subheading}>
      <h2 className={"layout-container"}>{props.text}</h2>
    </BgColor>
  )
}

export default SubHeading
